import React from 'react';

import {Box, Flex, Heading, Image, Link, Text} from '@spothero/ui';

import {
    userErrorImageProps,
    userErrorTextContentStyleProps,
} from '../error-display-style.props';

const ProductionMode = () => (
    <>
        <Image {...userErrorImageProps} />
        <Flex
            data-testid="ProductionMode-ErrorContent"
            {...userErrorTextContentStyleProps}
        >
            <Heading as="h3">Sorry we led you off the road!</Heading>
            <Box>
                <Text>
                    It looks like an error occurred. Refresh this page to try
                    again.
                </Text>
                <Text>
                    Still need help? Contact us at{' '}
                    <Link href="mailto:sellersupport@spothero.com?subject=SpotHero Control Panel Crash">
                        sellersupport@spothero.com
                    </Link>
                    .
                </Text>
            </Box>
        </Flex>
    </>
);

export default ProductionMode;
